import React, {} from 'react'
import {  } from 'react-router'
//import localStorageService, {keys} from '../services/LocalStorageService'
import Visits from './Visits'

const StartPage = (props) => {
    //const history= useHistory()

    /*
    useEffect(() => {
        const visit= localStorageService.getItem(keys.VISIT)
        const values= localStorageService.getItem(keys.VALUES)
        if (visit) {
            history.push({
                pathname: '/details',
                state: { visit, values }
            })
        }
    }, [history])
    */

    return (
        <Visits {...props} />
    )
}
export default StartPage
